<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'GUESTXP.GUESTXP' | transloco">
    <sbnb-gx-subnav></sbnb-gx-subnav>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'gx-overview'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="block sbnbDesktop:hidden m-0">Overview</h2>
      </sbnb-page-header>
    </app-feature-flag-tabs>
    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'gx-overview'"></sbnb-helptext-wrapper>

    <div
      class="overview__container"
      fxHide.lt-md
      fxLayout="row wrap"
      fxLayout.lt-md="column"
      fxLayoutAlign="space-between">
      <a class="overview__section" fxFlex="32" [routerLink]="['../rules']">
        <h1 *ngIf="counts && counts.rules !== undefined">
          {{ counts.rules }}
        </h1>
        <strong class="ocean">Active Messaging rules</strong>
        <p class="text__small">
          Rules are the building blocks that will create messages to your guests. They can be triggered after an event,
          scheduled ahead of time, or reply to a question.
        </p>
      </a>

      <a class="overview__section" fxFlex="32" [routerLink]="['../reviews']">
        <h1 *ngIf="counts && counts.reviews !== undefined">
          {{ counts.reviews }}
        </h1>
        <strong class="ocean">Active Review rules</strong>
        <p class="text__small">
          Review rules allow you to always publish reviews at the best time for your social proof. You always have
          control to publish the feedback you want to your guests.
        </p>
      </a>

      <a
        class="overview__section"
        fxFlex="32"
        [routerLink]="['../rules/segments/72f918b3-e6e8-4400-83e6-0d0a0b417fd1']">
        <h1 *ngIf="counts && counts.questions !== undefined">
          {{ counts.questions }}
        </h1>
        <strong class="ocean">Active Question rules</strong>
        <p class="text__small">
          Life was not made to send instructions. We have created machine learning models for your guest's most common
          questions. You only need to create the replies.
        </p>
      </a>
    </div>

    <mat-tab-group [@.disabled]="true">
      <mat-tab label="Pending messages">
        <mat-spinner class="overview__padding" *ngIf="loadingScheduledMessages" diameter="16"></mat-spinner>
        <ng-container *ngIf="scheduledMessages?.length > 0">
          <div class="overview__rules-container">
            <div
              *ngFor="let message of scheduledMessages"
              class="rules__rule-container"
              fxLayout
              fxLayoutAlign="start center"
              fxLayoutGap="8px">
              <a fxFlex class="overview__name ellipsis" (click)="openEditMessageDialog(message.randomkey)">
                <strong>{{ message.title }}</strong>
                <img
                  *ngIf="
                    message.ai_improvement?.has === true &&
                    message.ai_improvement?.edited === false &&
                    message.ai_improvement?.rejected === false
                  "
                  style="margin-left: 6px; display: inline-block"
                  src="/assets/iconography/magic.svg"
                  alt="AI improved icon"
                  matTooltip="Message set to improve with AI"
                  width="16" />
              </a>

              <a
                class="text__small"
                fxFlex
                fxLayout
                fxLayoutAlign="start center"
                fxLayoutGap="8px"
                fxFlex.lt-md="48px"
                [routerLink]="['/inbox/thread/' + message.thread_uuid]">
                <img
                  class="border-radius-50"
                  width="24"
                  height="24"
                  [src]="message?.guest?.picture ? message.guest.picture : ''"
                  onerror="this.src='/assets/images/profile-default.png'" />
                <span fxHide.lt-md>{{ message.guest.name }}</span>
              </a>

              <a
                class="text__small"
                fxFlex
                fxLayout
                fxLayoutAlign="start center"
                fxLayoutGap="8px"
                fxFlex.lt-md="48px"
                [routerLink]="['/properties/property/' + message.property.id]">
                <img
                  *ngIf="message.property?.picture"
                  [src]="message.property.picture"
                  width="32"
                  height="24"
                  fxFlex="32px" />
                <span *ngIf="message.property?.name" class="ellipsis" fxHide.lt-md>{{ message.property.name }}</span>
              </a>

              <span class="text__small night-lighter" fxFlex="70px" [matTooltip]="message.scheduled_for_label">
                in {{ message.scheduled_for | timeAgo: false }}
              </span>

              <button
                mat-flat-button
                fxHide.lt-md
                class="button__secondary button__small"
                (click)="openEditMessageDialog(message.randomkey)">
                Edit
              </button>
            </div>
          </div>

          <div fxLayoutAlign="end end">
            <button mat-flat-button>
              <a [routerLink]="['../log/scheduled']" [queryParams]="{ pending: 'true' }">Show more</a>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="scheduledMessages?.length === 0">
          <span class="smoke-darker overview__padding">You do not appear to have any scheduled messages 🤔.</span>
        </ng-container>
      </mat-tab>

      <mat-tab label="Pending reviews">
        <mat-spinner class="overview__padding" *ngIf="loadingScheduledReviews" diameter="16"></mat-spinner>
        <ng-container *ngIf="scheduledReviews?.length > 0">
          <div class="overview__rules-container">
            <div
              *ngFor="let message of scheduledReviews"
              class="rules__rule-container"
              fxLayout
              fxLayoutAlign="start center"
              fxLayoutGap="8px">
              <a fxFlex class="overview__name ellipsis" (click)="openEditReviewDialog(message.review_id)">
                <strong>{{ message.title }}</strong>
              </a>

              <a
                class="text__small"
                fxFlex
                fxLayout
                fxLayoutAlign="start center"
                fxLayoutGap="8px"
                fxFlex.lt-md="48px"
                [routerLink]="['/inbox/thread/' + message.thread_uuid]">
                <img
                  class="border-radius-50"
                  width="24"
                  height="24"
                  [src]="message?.guest?.picture ? message.guest.picture : ''"
                  onerror="this.src='/assets/images/profile-default.png'" />
                <span fxHide.lt-md>{{ message.guest.name }}</span>
              </a>

              <a
                class="text__small"
                fxFlex
                fxLayout
                fxLayoutAlign="start center"
                fxLayoutGap="8px"
                fxFlex.lt-md="48px"
                [routerLink]="['/properties/property/' + message.property.id]">
                <img
                  *ngIf="message.property?.picture"
                  [src]="message.property.picture"
                  width="32"
                  height="24"
                  fxFlex="32px" />
                <span *ngIf="message.property?.name" class="ellipsis" fxHide.lt-md>{{ message.property.name }}</span>
              </a>

              <span
                *ngIf="message.scheduled_for_label"
                class="text__small night-lighter"
                fxFlex="70px"
                [matTooltip]="message.scheduled_for_label">
                in {{ message.scheduled_for | timeAgo: false }}
              </span>

              <span
                *ngIf="!message.scheduled_for_label && message.expires_at_label"
                class="text__small night-lighter"
                fxFlex="100px"
                [matTooltip]="message.expires_at">
                expires in {{ message.expires_at | timeAgo: false }}
              </span>

              <button
                mat-flat-button
                fxHide.lt-md
                class="button__secondary button__small"
                (click)="openEditReviewDialog(message.review_id)">
                Edit
              </button>
            </div>
          </div>

          <div fxLayoutAlign="end end">
            <button mat-flat-button>
              <a [routerLink]="['../log/reviews']" [queryParams]="{ pending: 'true' }">Show more</a>
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="scheduledReviews?.length === 0">
          <span class="smoke-darker overview__padding">You do not appear to have any scheduled reviews 🤔.</span>
        </ng-container>
      </mat-tab>

      <mat-tab label="Pending review replies">
        <mat-spinner class="overview__padding" *ngIf="loadingReviewReplies" diameter="16"></mat-spinner>

        <ng-container *ngIf="reviewReplies?.length === 0">
          <span class="smoke-darker overview__padding">You do not appear to have any pending review replies 🤔.</span>
        </ng-container>

        <ng-container *ngIf="reviewReplies?.length > 0">
          <div class="overview__rules-container">
            <ng-container *ngFor="let message of reviewReplies">
              <div
                class="rules__rule-container"
                fxLayout
                fxLayoutAlign="start center"
                fxLayoutGap="16px"
                (click)="toggleExpandedReview(message.id)">
                <a class="overview__name ellipsis" fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                  <img
                    class="border-radius-50"
                    width="24"
                    height="24"
                    [src]="message.from.thumbnail_url"
                    onerror="this.src='/assets/images/profile-default.png'" />
                  <strong>{{ message.from.name }} left a review</strong>
                  <img
                    class="overview__arrow"
                    [class.expanded]="expandedReviews.includes(message.id)"
                    src="/assets/images/down-arrow.svg"
                    width="14"
                    alt="toggle detail" />
                </a>

                <a
                  fxHide.lt-md
                  class="text__small"
                  fxFlex
                  fxLayout
                  fxLayoutAlign="start center"
                  fxLayoutGap="8px"
                  fxFlex.lt-md="48px">
                  <img [src]="message.property?.picture" width="32" height="24" fxFlex="32px" />
                  <span class="ellipsis">{{ message.property?.name }}</span>
                </a>

                <sbnb-button type="secondary" size="mini">Edit</sbnb-button>
              </div>

              <div *ngIf="expandedReviews.includes(message.id)" style="margin: 6px 0 12px 0; padding-left: 36px">
                <sbnb-received-review-form
                  [message]="message"
                  [showGuestPicture]="false"
                  [showReviewContent]="true"
                  (replySent)="onPendingReviewReplySent($event)"></sbnb-received-review-form>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
